var _script, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetro3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1050 1050",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#9F971A",
    cx: 500,
    cy: 500,
    r: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M685.43 605.92c0-74.18-44.136-117.93-102.569-129.18v-1.348c56.139-21.041 85.376-63.202 85.376-117.89 0-70.614-61.407-133.66-170-133.66-61.646 0-112.91 17.197-158.63 47.393l36.784 78.104c17.334-15.098 49.443-38.637 98.372-38.637 55.725 0 81.198 29.562 81.198 63.363 0 40.537-32.211 66.135-84.189 66.135h-55.739v87.891h54.93c54.257 0 100.69 19.258 100.69 80.203 0 45.014-38.151 77.943-99.877 77.943-44.985 0-81.832-17.476-104.59-34.355l-40.291 81.59c42.788 24.134 84.03 39.943 152.19 39.943 123.31.07 206.35-74.43 206.35-167.47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro3);
export default __webpack_public_path__ + "static/media/metro3.c3196b9e286c46f43deae9606093f454.svg";
export { ForwardRef as ReactComponent };